import NewHireActionTypes from './new-hire.types';

export const getNewHireDataFailure = (error) => ({
  type: NewHireActionTypes.GET_DATA_FAILURE,
  payload: error,
});

export const getNewHireDataSuccess = (data) => ({
  type: NewHireActionTypes.GET_DATA_SUCCESS,
  payload: data,
});

export const getNewHireDataStart = () => ({
  type: NewHireActionTypes.GET_DATA_START,
});

export const setNewHireFirstName = (firstName) => ({
  type: NewHireActionTypes.SET_FIRST_NAME,
  payload: firstName.trim(),
});

export const clearNewHireFirstName = () => ({
  type: NewHireActionTypes.CLEAR_FIRST_NAME,
  payload: '',
});

export const setNewHireLastName = (lastName) => ({
  type: NewHireActionTypes.SET_LAST_NAME,
  payload: lastName.trim(),
});

export const clearNewHireLastName = () => ({
  type: NewHireActionTypes.CLEAR_LAST_NAME,
  payload: '',
});

export const setNewHireDepartment = (department) => ({
  type: NewHireActionTypes.SET_CURR_DEPARTMENT,
  payload: department,
});

export const clearNewHireDepartment = () => ({
  type: NewHireActionTypes.CLEAR_CURR_DEPARTMENT,
  payload: '',
});

export const setNewHirePosition = (position) => ({
  type: NewHireActionTypes.SET_CURR_POSITION,
  payload: position,
});

export const clearNewHirePosition = () => ({
  type: NewHireActionTypes.CLEAR_CURR_POSITION,
  payload: '',
});

export const setNewHireDoh = (doh) => ({
  type: NewHireActionTypes.SET_HIRE_DATE,
  payload: doh,
});

export const clearNewHireDoh = () => ({
  type: NewHireActionTypes.CLEAR_HIRE_DATE,
  payload: '',
});

export const setNewHireLocalDistros = (localDistros) => ({
  type: NewHireActionTypes.SET_LOCAL_DISTROS,
  payload: localDistros,
});

export const clearNewHireLocalDistros = () => ({
  type: NewHireActionTypes.CLEAR_LOCAL_DISTROS,
  payload: [],
});

export const setGoogleGroups = (googleGroups) => ({
  type: NewHireActionTypes.SET_GOOGLE_GROUPS,
  payload: googleGroups,
});

export const setAzureGroups = (azureGroups) => ({
  type: NewHireActionTypes.SET_AZURE_GROUPS,
  payload: azureGroups,
});

export const setNoc = (nocObj) => ({
  type: NewHireActionTypes.SET_NOC,
  payload: nocObj,
});

export const setNavitaire = (navitaireObj) => ({
  type: NewHireActionTypes.SET_NAVITAIRE,
  payload: navitaireObj,
});

export const setNewHireLocation = (location) => ({
  type: NewHireActionTypes.SET_LOCATION,
  payload: location,
});

export const setUber = (uberObj) => ({
  type: NewHireActionTypes.SET_UBER,
  payload: uberObj,
});

export const setLyft = (lyftObj) => ({
  type: NewHireActionTypes.SET_LYFT,
  payload: lyftObj,
});
